export class ReleasedElectrodePara {
    constructor({
        id= ``,
        prdDate= ``,
        locName= ``,
        locId= ``,
        shiftName= ``,
        furnaceNumber= ``,
        furnaceTime= ``,
        aPrimaryCurrent= ``,
        aGear= ``,
        aElectrodePosition= ``,
        aWeight= ``,
        aElectrodeCurrent= ``,
        aResistance= ``,
        aPressure= ``,
        aBottomTemp= ``,
        bPrimaryCurrent= ``,
        bGear= ``,
        bElectrodePosition= ``,
        bWeight= ``,
        bElectrodeCurrent= ``,
        bResistance= ``,
        bPressure= ``,
        bBottomTemp= ``,
        cPrimaryCurrent= ``,
        cGear= ``,
        cElectrodePosition= ``,
        cWeight= ``,
        cElectrodeCurrent= ``,
        cResistance= ``,
        cPressure= ``,
        cBottomTemp= ``,
        ambientTemp= ``,
    }={}){
        this.id = id;
        this.prdDate = prdDate;
        this.locName = locName;
        this.locId = locId;
        this.shiftName = shiftName;
        this.furnaceNumber = furnaceNumber;
        this.furnaceTime = furnaceTime;
        this.aPrimaryCurrent = aPrimaryCurrent;
        this.aGear = aGear;
        this.aElectrodePosition = aElectrodePosition;
        this.aWeight = aWeight;
        this.aElectrodeCurrent = aElectrodeCurrent;
        this.aResistance = aResistance;
        this.aPressure = aPressure;
        this.aBottomTemp = aBottomTemp;
        this.bPrimaryCurrent = bPrimaryCurrent;
        this.bGear = bGear;
        this.bElectrodePosition = bElectrodePosition;
        this.bWeight = bWeight;
        this.bElectrodeCurrent = bElectrodeCurrent;
        this.bResistance = bResistance;
        this.bPressure = bPressure;
        this.bBottomTemp = bBottomTemp;
        this.cPrimaryCurrent = cPrimaryCurrent;
        this.cGear = cGear;
        this.cElectrodePosition = cElectrodePosition;
        this.cWeight = cWeight;
        this.cElectrodeCurrent = cElectrodeCurrent;
        this.cResistance = cResistance;
        this.cPressure = cPressure;
        this.cBottomTemp = cBottomTemp;
        this.ambientTemp = ambientTemp;
    }
}

export function gridFields() {
    return Object.freeze([
        {
            key: 'prdDate',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          filterable: true,
          default: 'default',
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "locName", // 显示的属性的名称
              submitProp: "locName" // 提交的属性
            }
          }
        },
        {
          key: 'locId',
          label: 'lbl.formulaPlan.locationCode',
          notInTable: true,
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "id", // 显示的属性的名称
              submitProp: "id" // 提交的属性
            }
          }
        },
        {
            key: 'shiftName',
            label: 'lbl.shiftPlan.shiftName',
            sortable: true,
            default: 'default',
            form: {
              type: 'select',
              options: [
                {value:"default",text:"lbl.basic.select.one"},
                {value:"甲",text:"lbl.shift.A"},
                {value:"乙",text:"lbl.shift.B"},
                {value:"丙",text:"lbl.shift.C"}
              ]
            }
        },
        {
            key: 'furnaceNumber',
            label: 'lbl.basic.furnaceName',
            sortable: true,
            default: 'default',
            form: {
              type: 'select',
              options: [
                {value:"default",text:"lbl.basic.select.one"},
                {value:"1",text:"opt.furnaceNumber1"},
                {value:"2",text:"opt.furnaceNumber2"},
                {value:"3",text:"opt.furnaceNumber3"},
                {value:"4",text:"opt.furnaceNumber4"},
                {value:"5",text:"opt.furnaceNumber5"},
                {value:"6",text:"opt.furnaceNumber6"}
              ]
            }
        },
        {
            key: 'furnaceTime',
            label: 'lbl.basic.furnaceBatch',
            uneditable: true,
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aPrimaryCurrent',
            label: 'lbl.pdm.aPrimaryCurrent',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aGear',
            label: 'lbl.pdm.aGear',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aElectrodePosition',
            label: 'lbl.pdm.aElectrodePosition',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aWeight',
            label: 'lbl.pdm.aWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aElectrodeCurrent',
            label: 'lbl.pdm.aElectrodeCurrent',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aResistance',
            label: 'lbl.pdm.aResistance',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aPressure',
            label: 'lbl.pdm.aPressure',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'aBottomTemp',
            label: 'lbl.pdm.bottomTemp1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bPrimaryCurrent',
            label: 'lbl.pdm.bPrimaryCurrent',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bGear',
            label: 'lbl.pdm.bGear',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bElectrodePosition',
            label: 'lbl.pdm.bElectrodePosition',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bWeight',
            label: 'lbl.pdm.bWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bElectrodeCurrent',
            label: 'lbl.pdm.bElectrodeCurrent',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bResistance',
            label: 'lbl.pdm.bResistance',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bPressure',
            label: 'lbl.pdm.bPressure',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'bBottomTemp',
            label: 'lbl.pdm.bottomTemp2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cPrimaryCurrent',
            label: 'lbl.pdm.cPrimaryCurrent',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cGear',
            label: 'lbl.pdm.cGear',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cElectrodePosition',
            label: 'lbl.pdm.cElectrodePosition',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cWeight',
            label: 'lbl.pdm.cWeight',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cElectrodeCurrent',
            label: 'lbl.pdm.cElectrodeCurrent',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cResistance',
            label: 'lbl.pdm.cResistance',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cPressure',
            label: 'lbl.pdm.cPressure',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'cBottomTemp',
            label: 'lbl.pdm.bottomTemp3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'ambientTemp',
            label: 'lbl.pdm.ambientTemp',
            sortable: true,
            form: {
              type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new ReleasedElectrodePara()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.locNameFilter',
    'filter.shiftNameFilter',
    'filter.furnaceNumberFilter',
];

export const filter = {
    'startTimeFilter': '',
    'endTimeFilter': '',
    'locNameFilter': "default",
    'shiftNameFilter': "default",
    'furnaceNumberFilter':"default",
};